import gql from "graphql-tag";

export const GET_EMAIL_ADDRESS = gql`
    query EmailAddress($emailAddressId: ID!){
        emailAddress(emailAddressId: $emailAddressId) {
            emailAddressId
            userId
            parentType
            parentId
            emailAddressType
            emailAddress
            primary
            optedOut,
            optedOutAt,
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

export const GET_EMAIL_ADDRESSES = gql`
    query EmailAddresses($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        emailAddresses(parentType: $parentType, parentId: $parentId, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            emailAddressId
            userId
            parentType
            parentId
            emailAddressType
            emailAddress
            primary
            optedOut,
            optedOutAt,
            validatedAt
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

export const GET_EMAIL_ADDRESSES_OF_PARENT = gql`
    query EmailAddressesOfParent($parentType: String!, $parentId: ID!, $searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        emailAddressesOfParent(parentType: $parentType, parentId: $parentId, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            emailAddressId
            userId
            parentType
            parentId
            emailAddressType
            emailAddress
            primary
            optedOut,
            optedOutAt,
            validatedAt
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

export const CREATE_EMAIL_ADDRESS = gql`
    mutation CreateEmailAddress($newEmailAddress: newEmailAddress!) {
        createEmailAddress(
            newEmailAddress: $newEmailAddress
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_EMAIL_ADDRESS = gql`
    mutation UpdateEmailAddress($changedEmailAddress: changedEmailAddress!) {
        updateEmailAddress(
            changedEmailAddress: $changedEmailAddress
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_EMAIL_ADDRESS = gql`
    mutation DeleteEmailAddress($deleteEmailAddressId: ID!) {
        deleteEmailAddress(
            deleteEmailAddressId: $deleteEmailAddressId
        ) {
            returnCode
            message
        }
    }
`;
